import { FileClock } from 'lucide-react';
import { isProjectVersion } from '@obraplan/core/domain/structure/project';
import { useContainer, useSessionState } from '@/features/session/use-session';
import { useLive } from '@/lib/use-live';

/**
 * O aviso do topo das telas de execução (RDO, conferência, programação do dia,
 * planejamento) quando a obra ativa é uma **versão de orçamento** (07/10/2026).
 *
 * A execução acompanha a versão aprovada: lançar o dia numa versão não quebra nada, mas
 * ninguém vai olhar para ele. A tela não se esconde — a versão pode ser aprovada amanhã —,
 * o aviso só diz onde a execução de verdade está e leva até lá.
 */
export function ProjectVersionNotice() {
  const container = useContainer();
  const { session, activeProjectId, selectProject } = useSessionState();

  const projects = useLive(
    () =>
      session === undefined
        ? Promise.resolve([])
        : container.listAccessibleProjects.execute(session),
    [session?.userId],
  );

  const active = projects?.find((project) => project.id === activeProjectId);
  if (active === undefined || !isProjectVersion(active)) return null;

  const approved = projects?.find((project) => project.id === active.versionOf);

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border border-(--color-state-warn) bg-(--color-state-warn)/10 px-4 py-3 text-sm print:hidden"
    >
      <FileClock className="size-4 shrink-0 text-(--color-state-warn)" aria-hidden="true" />
      <p className="min-w-0 flex-1">
        Esta obra é uma versão de orçamento — a execução acompanha a versão aprovada.
      </p>
      {approved !== undefined && (
        <button
          type="button"
          className="font-medium underline underline-offset-2"
          onClick={() => void selectProject(approved.id)}
        >
          Abrir {approved.name}
        </button>
      )}
    </div>
  );
}
